import React from 'react';

interface Props {
  width?: string;
  height?: string;
}

const BestSellerSvg: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      width={width ?? '55'}
      height={height ?? '9'}
      viewBox='0 0 55 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.27724 2.64298C5.27724 3.38331 4.84935 3.99104 4.1033 4.28939V4.33358C5.06878 4.57668 5.65027 5.27281 5.65027 6.17889C5.65027 7.50486 4.70673 8.35568 2.92936 8.35568H0V0.620878H2.66605C4.43244 0.620878 5.27724 1.36121 5.27724 2.64298ZM3.52182 2.91922C3.52182 2.48828 3.24753 2.16784 2.67702 2.16784H1.76639V3.65955H2.7209C3.21462 3.65955 3.52182 3.35016 3.52182 2.91922ZM3.7961 5.99104C3.7961 5.49381 3.43404 5.15126 2.86353 5.15126H1.76639V6.80872H2.86353C3.47793 6.80872 3.7961 6.45513 3.7961 5.99104Z'
        fill='black'
      />
      <path
        d='M11.112 8.35568H6.26269V0.620878H11.0023V2.16784H8.02909V3.6264H10.4318V5.10707H8.02909V6.80872H11.112V8.35568Z'
        fill='black'
      />
      <path
        d='M11.6409 2.85292C11.6409 1.11812 13.0123 0.488281 14.3728 0.488281C14.9872 0.488281 15.6235 0.620878 16.0295 0.830822V2.44408C15.6235 2.20099 15.0969 2.03524 14.6141 2.03524C13.912 2.03524 13.4951 2.34463 13.4951 2.85292C13.4951 4.13469 16.5012 3.44961 16.5012 6.09049C16.5012 7.8474 15.1188 8.48828 13.5828 8.48828C12.9026 8.48828 12.1785 8.35568 11.608 8.14574V6.53248C12.2224 6.77557 12.8368 6.94132 13.4183 6.94132C14.2192 6.94132 14.6471 6.60983 14.6471 6.09049C14.6471 4.78662 11.6409 5.46066 11.6409 2.85292Z'
        fill='black'
      />
      <path
        d='M16.4946 2.16784V0.620878H22.2436V2.16784H20.2468V8.34463H18.4804V2.16784H16.4946Z'
        fill='black'
      />
      <path
        d='M22.4627 2.85292C22.4627 1.11812 23.8341 0.488281 25.1946 0.488281C25.809 0.488281 26.4453 0.620878 26.8513 0.830822V2.44408C26.4453 2.20099 25.9187 2.03524 25.436 2.03524C24.7338 2.03524 24.3169 2.34463 24.3169 2.85292C24.3169 4.13469 27.323 3.44961 27.323 6.09049C27.323 7.8474 25.9406 8.48828 24.4047 8.48828C23.7244 8.48828 23.0003 8.35568 22.4298 8.14574V6.53248C23.0442 6.77557 23.6586 6.94132 24.2401 6.94132C25.041 6.94132 25.4689 6.60983 25.4689 6.09049C25.4689 4.78662 22.4627 5.46066 22.4627 2.85292Z'
        fill='black'
      />
      <path
        d='M32.7557 8.35568H27.9063V0.620878H32.646V2.16784H29.6727V3.6264H32.0755V5.10707H29.6727V6.80872H32.7557V8.35568Z'
        fill='black'
      />
      <path
        d='M33.5369 0.620878H35.3033V6.80872H38.0461V8.35568H33.5369V0.620878Z'
        fill='black'
      />
      <path
        d='M38.5567 0.620878H40.3231V6.80872H43.066V8.35568H38.5567V0.620878Z'
        fill='black'
      />
      <path
        d='M48.4259 8.35568H43.5766V0.620878H48.3162V2.16784H45.343V3.6264H47.7457V5.10707H45.343V6.80872H48.4259V8.35568Z'
        fill='black'
      />
      <path
        d='M54.6709 3.07392C54.6709 3.99104 54.232 4.87502 53.1458 5.22861V5.27281L55 8.34463H52.7728L51.5769 5.538H50.9735V8.34463H49.2071V0.620878H51.8293C53.7931 0.620878 54.6709 1.83635 54.6709 3.07392ZM52.8167 3.10707C52.8167 2.62088 52.5314 2.16784 51.7086 2.16784H50.9735V4.05734H51.7086C52.5205 4.05734 52.8167 3.5822 52.8167 3.10707Z'
        fill='black'
      />
    </svg>
  );
};

export default BestSellerSvg;
